import React, { useState, useEffect, useRef } from "react";
import { Controller, Scene } from "react-scrollmagic";
import AOS from "aos";
import "../styles/_global.scss";
import Header from "./Header";
import Kv from "./Kv";
import ScrollBtn from "./ScrollBtn";
import TainanVideo from "./TainanVideo";
import Articles from "./Articles";
import Kol from "./Kol";
import HotSearch from "./HotSearch";
import Store from "./Store";
import Hashtag from "./Hashtag";
import Ota from "./Ota";
import Partners from "./Partners";
import Footer from "./Footer";
import FloatIcon from "../images/float_icon.svg";
import { Tween, Timeline } from "react-gsap";

const App = () => {
    const screenWidth = useRef(window.innerWidth).current;
    const [mobileNavOpen, setMobileNavOpen] = useState(false);
    const menuContent = [
        { title: "刻在心底的台南味", id: "articles" },
        { title: "潮Ｗay達人導航", id: "kol" },
        { title: "百大熱搜指南", id: "hotSearch" },
        { title: "潛力特色店家", id: "store" },
        { title: "全民踩點來卡Way", id: "hashtag" },
        { title: "台南精選體驗", id: "ota" }
    ];

    const toggleMobileNav = () => {
        setMobileNavOpen(!mobileNavOpen);
    };

    const body = document.querySelector("body");
    if (mobileNavOpen) {
        // 背景禁止滾動
        body.style.overflow = "hidden";
    } else {
        body.style.overflowX = "hidden";
        body.style.overflowY = "auto";
    }

    // 埋設 GA 瀏覽整個活動網頁傳送參數
    const sendGaEventView = (e) => {
        gtag("event", "View", {
            "event_category": "Event",
            "event_label": "Event_view",
            "value": 1
        });
    };

    useEffect(() => {
        AOS.init();
        sendGaEventView();
    }, []);

    return (
        <Controller>
            {
                screenWidth <= 768 ?
                    <>
                        <Header
                            mobileNavOpen={mobileNavOpen}
                            menuContent={menuContent}
                            toggleMobileNav={toggleMobileNav}
                        />
                        <Kv />
                        <ScrollBtn mobileNavOpen={mobileNavOpen} />
                    </>
                    :
                    <Scene triggerHook="onLeave" duration={2500} pin>
                        {(progress) => (
                            <div className="sticky">
                                <Header
                                    mobileNavOpen={mobileNavOpen}
                                    menuContent={menuContent}
                                    toggleMobileNav={toggleMobileNav}
                                />
                                <Kv progress={progress} />
                                <ScrollBtn />
                            </div>
                        )}
                    </Scene>

            }
            <Scene triggerElement={".articles"} duration={300}>
                <Timeline>
                    <TainanVideo />
                    <Articles />
                    <Kol />
                    <HotSearch />
                    <Tween
                        from={{ opacity: 0 }}
                        to={{ opacity: 1 }}
                    >
                        <a
                            href="/"
                            className="float-icon"
                            onClick={(e) => {
                                let element = document.querySelector("#hashtag");
                                e.preventDefault();
                                element && element.scrollIntoView({ behavior: "smooth", block: "start" });
                            }}
                            rel="noreferrer"
                        >
                            <img src={FloatIcon} width={180} height={129} alt="float-icon" />
                        </a>
                    </Tween>
                    <div className="bg-c">
                        <Store />
                        <Hashtag />
                        <Ota />
                        <Partners />
                    </div>
                    <Footer />
                </Timeline>
            </Scene>
        </Controller>
    );
};

export default App;
